import { useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import type { RootState } from '@/rootReducer';
import { useHistory } from 'react-router-dom';
import { useSequences } from './useSequences';
import { useSequencesContext } from '../SequencesContext';

export default function useStartSequence() {
	const {
		setSequencePage,
		setSelectedLists,
		setSelectedSequence,
		templates,
		setSelectedTemplate
	} = useSequencesContext();
	const { resetSequenceState, fetchSequences } = useSequences();

	const history = useHistory();

	const [listSelected] = useSelector(
		(state: RootState) => [
			state.dashboard.getIn(['lists', 'selected']).toJS()
		],
		shallowEqual
	);

	async function checkForUrlParams() {
		const searchParams = new URLSearchParams(window.location.search);
		const listId = searchParams.get('listId');

		if (listId) {
			// Remove listId from the URL
			searchParams.delete('listId');
			history.replace({ search: searchParams.toString() });

			setSelectedSequence({
				name: 'New sequence',
				steps: [],
				status: 'DRAFT',
				justCreated: true
			});
			if (templates) {
				setSelectedTemplate(templates[0]);
			}
			setSequencePage('SEQUENCE-START');
			setSelectedLists([listSelected]);

			return true;
		}

		return false;
	}

	async function handleStartSequence() {
		const hasListIdSuccess = await checkForUrlParams();

		if (!hasListIdSuccess) {
			// Reset states related to sequences
			resetSequenceState();
			fetchSequences();
		}
	}

	useEffect(() => {
		// Checking if the user is coming from a list
		handleStartSequence();
	}, []);
}
